$('#mobile-menu-button').on('click', function(){
  if( !$(this).hasClass('is-active') ){
    openMenu($(this), '#mobile-menu-bg', '#mobile-menu');
  } else {
    closeMenu($(this), '#mobile-menu-bg', '#mobile-menu');
  }
});

function openMenu(btn, overlay, element, hideBtn) {
    hideBtn = typeof hideBtn !== 'undefined' ? hideBtn : false;
    $(document).delegate(overlay, 'touchmove', false);
    $(document).delegate(element, 'touchmove', false);
    var overlaySelector = $(overlay);
    var elementSelector = $(element);
    var navbar = $('#navbar');
    overlaySelector.css('display', 'block');
    elementSelector.css('display', 'table');
    elementSelector.css('top', $(window).scrollTop() + navbar.outerHeight());
    if (hideBtn) {
        btn.css('display', 'block');
        setTimeout(function() {
            btn.addClass('is-active');
        }, 10);
    } else {
        btn.addClass('is-active');
    }
    setTimeout(function() {
        overlaySelector.addClass('is-active');
        elementSelector.addClass('is-active');
    }, 10);
}

function closeMenu(btn, overlay, element, hideBtn) {
    hideBtn = typeof hideBtn !== 'undefined' ? hideBtn : false;
    btn.removeClass('is-active');
    var overlaySelector = $(overlay);
    var elementSelector = $(element);
    overlaySelector.removeClass('is-active');
    elementSelector.removeClass('is-active');
    setTimeout(function() {
        if (hideBtn) {
            btn.css('display', 'none');
        }
        overlaySelector.css('display', 'none');
        elementSelector.css('display', 'none');
        $(document).undelegate(overlay, 'touchmove', false);
        $(document).undelegate(element, 'touchmove', false);
    }, 410);
}


// WEBPACK FOOTER //
// ./public/javascripts/modules/mobileMenu.js